import React from "react"
import { HTMLAttributes } from "react"

type CheckSolidProps = HTMLAttributes<SVGElement> & {
  size?: string
}

export function CheckSolid({ size = "24px", ...props }: CheckSolidProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17316C21.7413 9.38642 22 10.6868 22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268 21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8078C8.10929 21.422 6.32746 20.4696 4.92894 19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.76121 8.17316C3.51809 6.3459 4.79981 4.78412 6.4443 3.6853ZM16.4255 9.52473C16.4257 9.51651 16.4258 9.50829 16.4258 9.50006C16.4258 9.36805 16.3996 9.23734 16.3489 9.11548C16.2981 8.99362 16.2237 8.88302 16.13 8.79006C15.9426 8.60381 15.6892 8.49927 15.425 8.49927C15.1608 8.49927 14.9074 8.60381 14.72 8.79006L10.43 13.0901L8.77999 11.4401C8.69034 11.3354 8.58002 11.2504 8.45596 11.1903C8.33189 11.1303 8.19676 11.0966 8.05904 11.0913C7.92132 11.0859 7.78399 11.1091 7.65567 11.1594C7.52734 11.2097 7.41079 11.286 7.31334 11.3834C7.21588 11.4809 7.13963 11.5974 7.08935 11.7257C7.08543 11.7358 7.08166 11.7458 7.07807 11.7559C7.0529 11.8269 7.03586 11.9003 7.02718 11.9747C7.02122 12.0258 7.0192 12.0774 7.02119 12.1291C7.02651 12.2668 7.06024 12.402 7.12026 12.526C7.18029 12.6501 7.26531 12.7604 7.36999 12.8501L9.71999 15.2101C9.81343 15.3027 9.92425 15.3761 10.0461 15.4258C10.1679 15.4756 10.2984 15.5008 10.43 15.5001C10.6923 15.499 10.9437 15.3948 11.13 15.2101L16.13 10.2101C16.2103 10.1304 16.2764 10.0379 16.3256 9.93636C16.3302 9.92675 16.3347 9.91706 16.3391 9.90729C16.3424 9.89978 16.3457 9.89223 16.3489 9.88463M16.3489 9.88463C16.3965 9.77039 16.4224 9.64831 16.4255 9.52473L16.3489 9.88463Z"
        fill="currentColor"
      />
    </svg>
  )
}
